import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col min-h-screen" }
const _hoisted_2 = { class: "flex-grow bg-background" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-row mt-8"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col card-main mr-4" }, "Sidebar", -1)
const _hoisted_6 = { class: "flex flex-col flex-grow card-main" }
const _hoisted_7 = { class: "flex flex-col mt-8" }
const _hoisted_8 = { class: "flex flex-row text-center" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "h-px my-4 bg-gray-300 w-full" }, null, -1)
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = { class: "flex flex-row items-center justify-end mt-8" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Add new collaborator")
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "flex flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_CompanyCard = _resolveComponent("CompanyCard")!
  const _component_CollaboratorsTable = _resolveComponent("CollaboratorsTable")!
  const _component_ModalAddMember = _resolveComponent("ModalAddMember")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Loader, {
              key: 0,
              class: "mt-8"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_CompanyCard, {
                  companyName: _ctx.company.visible_name,
                  isBigCard: true
                }, null, 8, ["companyName"]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item, i) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: i,
                        class: _normalizeClass(["capitalize font-medium mx-2", {
                    'text-gray-400': !item.selected,
                    'text-black font-semibold': item.selected,
                  }]),
                        onClick: ($event: any) => (_ctx.$router.push(`/client/${_ctx.company_id}/${item.name}`))
                      }, _toDisplayString(item.name.replaceAll("-", " ")), 11, _hoisted_9))
                    }), 128))
                  ]),
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        class: "space-x-3 btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-between truncate text-base bg-primary rounded-full transition duration-150 ease-in",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal = !_ctx.openModal))
                      }, _hoisted_14)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_CollaboratorsTable)
                ])
              ])
            ]))
      ])
    ]),
    (_ctx.openModal)
      ? (_openBlock(), _createBlock(_component_ModalAddMember, {
          key: 0,
          openModal: _ctx.openModal,
          "onUpdate:openModal": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.openModal) = $event))
        }, null, 8, ["openModal"]))
      : _createCommentVNode("", true)
  ]))
}